import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import ButtonIconGhostMedium from '../../../../components/common/ButtonIconGhost/ButtonIconGhostMedium';
import RightMenuDesign from '../../../../components/house/RightMenuDesign/RightMenuDesign';
import { Icon } from '../../../../components/icon/icon';
import { listHandle } from '../../../../dataTest/data';
import './RightDoorAccessoryDesignMenu.scss';
import { getValueFromString } from '../../../../utils/data/getValue.utils';
import CardProduct from '../../../../components/card/CardProduct/CardProduct';
import CardProductClick from '../../../../components/card/CardProduct/CardProductClick';

const RightDoorAccessoryDesignMenu = ({
  open,
  onClose,
  title,
  onClickCard,
}) => {
  const dispatch = useDispatch();

  const { door } = useSelector(state => state.doorAndHandle || {});

  // const [searchParams] = useSearchParams();
  // const productType = searchParams.get("product_type") || "";

  // useEffect(() => {
  //   if (!productType) return;
  //   dispatch(
  //     fetchDoorHandles({ product_type: productType, door_type: "HINGED" })
  //   );
  // }, [dispatch, productType]);

  return (
    <>
      <RightMenuDesign
        open={open}
        classNames={{ root: 'top-84', content: 'flex flex-col !p-0 gap-0' }}
        header={
          <div className="flex self-stretch items-center justify-start gap-8">
            <ButtonIconGhostMedium
              icon={<Icon.ICArrowBack />}
              onClick={onClose}
            />
            <span className="text-title-large">{title}</span>
          </div>
        }
        content={
          <>
            <div className="flex p-8 justify-start items-start gap-2 self-stretch flex-wrap overflow-auto">
              {/* {listHandle.map((md, i) => { */}
              {door?.data?.handles?.map((md, i) => {
                const name = getValueFromString(md.name);
                const description = getValueFromString(md.description);
                return (
                  <CardProductClick
                    key={i}
                    md={md}
                    title={name}
                    description1={description}
                    description2={md.size}
                    // description2={
                    //   <span className="text-body-small-emphasized font-semibold">
                    //     {md.price.toLocaleString('vi-VN', {
                    //       style: 'currency',
                    //       currency: 'VND',
                    //     })}
                    //   </span>
                    // }
                    moduleType={'moduleType'}
                    onClick={onClickCard}
                  />
                );
              })}
            </div>
          </>
        }
      />
    </>
  );
};

export default RightDoorAccessoryDesignMenu;
